import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["email", "form", "submitButton", "formAlert", "emailSent"];

    static values = {
        submitUrl: String,
    };

    recurrentJobId = null;

    connect() {
        this.modalElement = document.getElementById("anonymousContactProfileModal");

        if (this.modalElement && typeof jQuery !== "undefined") {
            jQuery(this.modalElement).on("show.bs.modal", this.handleModalShow.bind(this));
        }
    }

    handleModalShow(event) {
        const triggerButton = event.relatedTarget;

        if (triggerButton) {
            this.recurrentJobId = triggerButton.dataset.recurrentJobId || null;
            this.sourceElement = triggerButton;

            // Weitere Daten bei Bedarf speichern
            this.buttonText = triggerButton.textContent;
            this.buttonType = triggerButton.dataset.type;
        }

        this.resetForm();
    }

    resetForm() {
        if (this.hasEmailTarget) {
            this.emailTarget.value = "";
        }

        if (this.hasFormAlertTarget) {
            this.formAlertTarget.classList.add("d-none");
        }

        if (this.hasEmailSentTarget) {
            this.emailSentTarget.classList.add("d-none");
        }

        const checkbox = this.element.querySelector('input[type="checkbox"]');
        if (checkbox) {
            checkbox.checked = false;
        }
    }

    sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    async submit(event) {
        event.preventDefault();
        let result;

        if (!this.validateForm()) {
            return;
        }

        const formData = new FormData(this.formTarget);

        const response = await fetch(this.submitUrlValue, {
            method: "POST",
            body: formData,
            headers: {
                "X-Requested-With": "XMLHttpRequest",
                Accept: "application/json",
            },
        });

        const responseText = await response.text();

        if (!response.ok || responseText) {
            try {
                result = JSON.parse(responseText);
            } catch (e) {
                console.error("Response ist kein valides JSON:", responseText);
                throw new Error("Ungültige Server-Antwort");
            }
        }

        if (result !== undefined && result !== "") {
            this.showError(result.message);
            return;
        }

        this.formAlertTarget.classList.add("d-none");
        this.emailSentTarget.innerHTML =
            "Wir haben dir eine Bestätigungsmail an " + this.emailTarget.value + " gesendet.";
        this.emailSentTarget.classList.remove("d-none");

        await this.sleep(2000);

        window.location.href = "/de/stellenanzeigen/" + this.recurrentJobId;
    }

    validateForm() {
        this.clearError();
        let isValid = true;

        const emailValue = this.emailTarget.value;
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(emailValue)) {
            this.showError("Bitte gib eine gültige E-Mail-Adresse ein.");
            isValid = false;
        }

        return isValid;
    }

    showError(message) {
        this.formAlertTarget.innerHTML = message;
        this.formAlertTarget.classList.remove("d-none");
    }

    clearError() {
        this.emailTarget.classList.remove("is-invalid");
        const errors = this.element.querySelectorAll(".text-danger");
        errors.forEach((error) => error.remove());
    }
}
